import { Languages } from '@/common/utils/constants';
import { formatDate } from './formatDate';
import { calculateIncreasedDate } from './calculateIncreasedDate';

export interface LocaleDateStringFromTodayIncreasedByTimeProps {
  amount: number;
  unit: string;
  lang: Languages;
  startDate?: Date;
}

export const determineLocaleDateStringFromTodayIncreasedByTime = ({
  amount,
  unit,
  lang,
  startDate,
}: LocaleDateStringFromTodayIncreasedByTimeProps) => {
  const date = calculateIncreasedDate({
    amount,
    unit,
    startDate: new Date(startDate ?? ''),
  });
  if (date) {
    return formatDate(date, lang);
  }
};
